// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gallery-ctr{margin-bottom:150px}", "",{"version":3,"sources":["webpack://./src/views/pages/Gallery/Gallery.scss"],"names":[],"mappings":"AAAA,aAAa,mBAAmB","sourcesContent":[".gallery-ctr{margin-bottom:150px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
